import { StrictMode } from "react";
import { ContextProvider } from "../context/Context";
import Footer from "./Footer/Footer";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

const Layout = ({ children }) => {
  return (
    <StrictMode>
      <ContextProvider>
        <Navbar />
        <Sidebar />
        <main>{children}</main>
        <Footer  />
      </ContextProvider>
    </StrictMode>
  );
};

export default Layout;
